<template>
  <div>
    <!-- toasts message -->
    <v-card color="grey lighten-4">
      <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    </v-card>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->
    <v-container>
      <v-card>
        <v-card-title>

        <span class="headline"><h2>Audit Trial</h2></span> </br>

        <v-spacer></v-spacer>
        <v-flex xs12 sm6 md4>
          <DatePicker
          :key="1"
          :inputData="{index:1,fieldName:'start_date', fieldValue:start_date, label:'Start Date'}"
          @setValue="setStartDateValue"
          ></DatePicker>
        </v-flex>
        
        <v-spacer></v-spacer>
        <v-flex xs12 sm6 md4>
          <DatePicker
              :key="2"
              :inputData="{index:2,fieldName:'end_date', fieldValue:end_date, label:'End Date', disabled:'1'}"
              @setValue="setEndDateValue"
              ref="setRange"
          ></DatePicker>
        </v-flex>
        <v-spacer></v-spacer>
        
        &nbsp;&nbsp; 

          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md12>
            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          </v-flex>
        </v-card-title>
        <span style="display:none;">{{serial=serialNumber}}</span>
        <v-data-table
          :headers="headers"
          :items="desserts"
          :pagination.sync="pagination"
          :total-items="totalDesserts"
          :loading="loading"
          class="elevation-4"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ serial++ }}</td>
            <td class="text-xs-left">{{ props.item.module_name }}</td>
            <td class="text-xs-left">{{ props.item.sub_menu }}</td>
            <td class="text-xs-left">{{ props.item.user_name }}</td>
            <td class="text-xs-left">{{ props.item.action }}</td>
            <td class="text-xs-left">{{ changeFormateDMY(props.item.created_at) }}</td>
            
            <!-- <td class="">
              <v-btn icon class="mx-0" @click="addDetails(props.item)" title="Detail">
                <v-icon color="teal">view_module</v-icon>
              </v-btn>
            </td> -->

          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
let commonService = require("../../services/common.service");
import Axios from "axios";
import ServerPath from '../../server-path/server-path';
import DatePicker from "../global/date_picker";

export default {
  components: {
    DatePicker
  },

  data: () => ({
    showForm: false, // Add edit form controll during user permission
    dialog: false,
    totalItems: 0,

    items: [],
    MainMenus: [],
    //Delete data related instance--------
    delete_id: "",
    row_index: "",
    confirmModel: false,

    // snacber script instance ----------
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },
    start_date:'',
    end_date:'',
    formSchema: {
      id: "",
      asset_id: "",
      asset_code: "",
      asset_location_id: "",
      employee_id: "",
      new_asset_location_id:"",
      new_employee_id:"",
      issue_date: "",
      close_date: "",
      asset_status: "",
      issue_status: "",
    },

    /*############# Datatable #############*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      { text: "SL",sortable: true, value: "" },
      {
        text: "Module",
        align: "left",
        sortable: true,
        value: "module_name"
      },
      {
        text: "Sub Module",
        align: "left",
        sortable: true,
        value: "sub_menu"
      },
      {
        text: "User Name",
        align: "left",
        sortable: true,
        value: "user_name"
      },
      {
        text: "User Action",
        align: "left",
        sortable: true,
        value: "action"
      },
      {
        text: "Date",
        align: "left",
        sortable: true,
        value: "created_at"
      },
      
    ]
    /*############# /Datatable #############*/
  }),

  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          if ( typeof(data.items) !== 'undefined') {
            this.desserts = data.items;
          }
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    },

    // User Previlization methods
    userRole() {
      let role = this.$store.getters.get_USER_ROLE_DATA;
      this.showForm = role.saveButton;
      return role;
    }
  },

    created() {

  },

  methods: {

    setStartDateValue(data) {
    let index = data.index;
    this.start_date = data.value;

    if(data.index === 1){
        this.end_date = 0
        this.$refs.setRange.setRange(data.value);
    }
    this.findByStartDate()
    console.log(this.start_date,this.end_date)
    },
    setEndDateValue(data) {
        let index = data.index;
        this.end_date = data.value;
        this.findByEndDate()
        console.log(this.start_date,this.end_date)
    },

    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
            this.serialNumber = serialNumber + 1;

        commonService
          .insertFormData(query_Data, "audit_details")
          .then(res => {
            this.showForm = this.userRole.saveButton;
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            // if (rowsPerPage > 0) {
            //   items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage);
            // }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    //  Request response Massage !!!
    close(res) {
      this.showForm = this.userRole.saveButton;
    }
    // End  Request response Massage !!!
  }
};
</script>



// WEBPACK FOOTER //
// src/components/audit/auditDetails.vue